// import store from "../store";
let apiUrl = () => {
  return "/api";
};

let apiPrefix = (path) => {
  return apiUrl() + path;
};

export { apiUrl, apiPrefix };
